@layer tbw-plugins {
  .header-group-row {
    display: grid;
    grid-auto-flow: column;
    background: var(--tbw-grouping-columns-header-bg, var(--tbw-color-header-bg));
    border-bottom: 1px solid var(--tbw-grouping-columns-border, var(--tbw-color-border));
  }
  .header-group-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--tbw-button-padding-sm, 0.25rem 0.5rem);
    font-weight: 600;
    font-size: var(--tbw-font-size-sm, 0.9em);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    border-right: 2px solid
      var(--tbw-grouping-columns-separator, var(--tbw-color-border-strong, var(--tbw-color-border)));
  }
  .header-group-cell:last-child {
    border-right: none;
  }
  .header-row .cell.grouped {
    border-top: none;
  }
  .header-row .cell.group-end {
    border-right: 2px solid
      var(--tbw-grouping-columns-separator, var(--tbw-color-border-strong, var(--tbw-color-border)));
  }
  /* Last cell shouldn't have right border - avoids double border with grid edge */
  .header-row .cell.group-end:last-child {
    border-right: none;
  }

  /* Data cells in group-end columns - extends the strong border through all rows */
  .rows .cell.group-end {
    border-right: 2px solid
      var(--tbw-grouping-columns-separator, var(--tbw-color-border-strong, var(--tbw-color-border)));
  }
  /* Last cell in row shouldn't have right border */
  .rows .cell.group-end:last-child {
    border-right: none;
  }

  /* Hide borders when showGroupBorders is false */
  .header-group-row.no-borders {
    border-bottom: none;
  }
  .header-group-row.no-borders .header-group-cell {
    border-right: none;
  }
  .header-row.no-group-borders .cell.group-end {
    border-right: 1px solid var(--tbw-color-border);
  }
} /* End @layer tbw-plugins */
